// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import Requirements from './pages/Requirements';
import Navbar from './component/Navbar';
import { ToastContainer } from 'react-toastify';
import RequirementsList from './pages/RequirementList';
import ProtectedRoute from './component/ProtectedRoute';
import TermsAndConditions from './pages/TermsAndCondition';
import WhatsAppButton from './component/Whatsappbtn';
import ProjectDetails from './pages/projectDetails/ProjectDetails';
import ProjectsPage from './pages/projectDetails/ProjectCardPage';
import Rent_property from './pages/Rent/Rent_property_list'
import Rent_Form from './pages/Form/List_Property_Rent';
import RentPage from './pages/Rent/Rent_property_page';
import Sell_property_Card_page from './component/Sell_property/Sell_property_card_page';
import Sell_property_Details from "./component/Sell_property/Sell_property_Detail"
import AllBlogs from './pages/Blog/AllBlogs';
import BlogDetail from './pages/Blog/BlogDetail';
import Agent_listing from './component/Agent/Agent_listing';
import Appartment_cards from './component/Appartment_rent_in_society/Appartment_rent_cards';
import Appatrment_details from './component/Appartment_rent_in_society/Appartment_details';

const App = () => {
  useEffect(() => {
    // Track page views when component mounts or route changes
    const trackPageView = () => {
      if (window.gtag) {
        window.gtag("event", "page_view", {
          page_path: window.location.pathname,
        });
      }
    };

    trackPageView(); // Initial page load
    window.addEventListener("popstate", trackPageView); // Track route changes
    return () => {
      window.removeEventListener("popstate", trackPageView);
    };
  }, []);
  return (
    <Router>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/requirements" element={<Requirements />} />
        <Route path="/termsandcondition" element={<TermsAndConditions />} />
        <Route path="/project-details/:id" element={<ProjectDetails />} />
        <Route path='/project-card' element={<ProjectsPage />} />
        <Route path='/rent-list' element={<Rent_property />} />
        <Route path='/list-Property' element={<Rent_Form />} />
        <Route path='/for-rent-property/:id' element={<RentPage />} />
        <Route path='/Sell-property-in-lucknow' element={<Sell_property_Card_page />} />
        <Route path='/sell-property-detail' element={<Sell_property_Details />} />
        <Route path='/for-sale-property/:id' element={<Sell_property_Details />} />
        <Route path='/allBlogs' element={<AllBlogs />} />
        <Route path='/blog/:slug' element={<BlogDetail />} />
        <Route path='/agent-listing' element={<Agent_listing/>}/>
        <Route path='/appartment_for_rent' element={<Appartment_cards/>}/>
        <Route path='/appartment_details/:id' element={<Appatrment_details/>}/>
        <Route
          path="/requirementsList"
          element={
            <ProtectedRoute>
              <RequirementsList />
            </ProtectedRoute>
          }
        />
      </Routes>
      <ToastContainer /> {/* Add ToastContainer here */}
    </Router>
  );
};

export default App;
